import React from 'react';
import { Text, View } from 'react-native';

interface ProfileStatsProps {
  checkInCount: number;
  friendsCount: number;
}

export function ProfileStats({ checkInCount, friendsCount }: ProfileStatsProps) {
  return (
    <View className="flex-row justify-center gap-12 mb-4">
      <View className="items-center px-4">
        <Text className="text-xl font-bold text-foreground">
          {checkInCount}
        </Text>
        <Text className="text-sm text-muted-foreground">
          Check-ins
        </Text>
      </View>
      <View className="items-center px-4">
        <Text className="text-xl font-bold text-foreground">
          {friendsCount}
        </Text>
        <Text className="text-sm text-muted-foreground">
          Friends
        </Text>
      </View>
    </View>
  );
}
